import { ReactElement } from 'react';
import Image from 'next/image';
import { Box } from '@chakra-ui/react';

import image from '@public/purple-circle.svg';

import { BoxImageProps } from '../types';

const PurpleCircle = ({ layout, ...props }: BoxImageProps): ReactElement => (
  <Box {...props}>
    <Image src={image} alt='Circulo roxo' layout={layout} priority />
  </Box>
);

export default PurpleCircle;
